import { Send } from 'lucide-react';
import { useAuth } from '../../../contexts/AuthContext';
import { GmailConnectionProvider } from './taActionBoard/GmailConnectionContext';
import { useGmailToken } from './taActionBoard/useGmailToken';
import { OutreachTab } from './outreach/OutreachTab';

/**
 * 📨 Outreach — LinkedIn InMail drafts per role. Its own page (Sofia, Oct 13 2026) rather than a
 * tab on the TA Action Board: it is always the signed-in recruiter's own list, so the board's
 * "whose board am I on" picker never applied to it.
 *
 * Mounts its own Gmail grant: the kick-off sheet the brief is built from is read through it.
 * useGmailToken keeps the grant in sessionStorage, so connecting on the board covers this page in the same browser tab.
 */
export default function OutreachView() {
  const { user } = useAuth();
  const myEmail = (user?.email || '').toLowerCase();
  const gmail = useGmailToken(myEmail);

  return (
    <GmailConnectionProvider value={gmail}>
      <div className="mx-auto max-w-6xl px-4 py-6">
        <header className="flex items-start gap-3">
          <span className="grid h-10 w-10 place-items-center rounded-lg bg-[#DBEBFC] text-[#0072EA]">
            <Send className="h-5 w-5" />
          </span>
          <div>
            <h1 className="text-xl font-semibold text-gray-900">Outreach</h1>
            <p className="mt-1 max-w-2xl text-sm text-gray-500">
              LinkedIn InMails per role, in four steps: brief, find people, write &amp; send, log. InMails go out from your
              own LinkedIn Recruiter with the FINN Outreach Sender extension.
            </p>
          </div>
        </header>
        <OutreachTab myEmail={myEmail} />
      </div>
    </GmailConnectionProvider>
  );
}
